import { Database } from '@/types/supabase-types';

interface PersonalTabContentProps {
  employee: Omit<
    Database['ShiftSage']['Tables']['employees']['Row'],
    'department'
  > & { department: string };
}

export function PersonalTabContent({ employee }: PersonalTabContentProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">Full Name</p>
        <p className="font-medium">{`${employee.first_name} ${employee.last_name}`}</p>
      </div>
      
      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">Email</p>
        <p className="font-medium">{employee.email}</p>
      </div>
      
      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">Position</p>
        <p className="font-medium">{employee.position}</p>
      </div>
      
      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">Department</p>
        <p className="font-medium">{employee.department || 'N/A'}</p>
      </div>

      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">Shift</p>
        <p className="font-medium">{employee.shift || 'N/A'}</p>
      </div>

      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">Worker Type</p>
        <p className="font-medium">{employee.worker_type || 'N/A'}</p>
      </div>
      
      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">Status</p>
        <p className="font-medium">{employee.status || "Active"}</p>
      </div>
      
      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">Residency</p>
        <p className="font-medium">{employee.residency || "Resident"}</p>
      </div>
    </div>
  )
}
